import { render, staticRenderFns } from "./articleDetails.vue?vue&type=template&id=b3c7e2f8&scoped=true&"
import script from "./articleDetails.vue?vue&type=script&lang=js&"
export * from "./articleDetails.vue?vue&type=script&lang=js&"
import style0 from "./articleDetails.vue?vue&type=style&index=0&id=b3c7e2f8&scoped=true&lang=less&"
import style1 from "./articleDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c7e2f8",
  null
  
)

export default component.exports